import React from 'react';
import { Check } from 'lucide-react';

const PlatformCard = ({ title, description, price, sku, selected, onToggle, features, color, addon }) => {
  const colors = {
    blue: { border: 'border-blue-600', bg: 'bg-blue-50', text: 'text-blue-600', badge: 'bg-blue-100' },
    purple: { border: 'border-purple-600', bg: 'bg-purple-50', text: 'text-purple-600', badge: 'bg-purple-100' }
  };
  
  const c = colors[color];
  
  return (
    <button
      onClick={onToggle}
      className={`w-full p-6 rounded-xl border-2 transition-all text-left ${
        selected ? `${c.border} ${c.bg} shadow-lg` : 'border-slate-200 hover:border-slate-300'
      }`}
    >
      <div className="flex items-start justify-between mb-3">
        <div>
          <h4 className="font-bold text-lg text-slate-800">
            {title}
            {addon && (
              <span className={`ml-2 text-xs font-normal ${c.text} ${c.badge} px-2 py-1 rounded-full`}>
                Add-on
              </span>
            )}
          </h4>
          <p className="text-sm text-slate-600 mt-1">{description}</p>
          <p className="text-xs text-slate-400 mt-1">SKU: {sku}</p>
        </div>
        <div className="text-right">
          <div className={`text-2xl font-bold ${c.text}`}>{price}</div>
          <div className="text-xs text-slate-500">/year</div>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mt-4">
        {features.map(feature => (
          <span key={feature} className="text-xs px-3 py-1 bg-white border border-slate-200 rounded-full text-slate-600">
            {feature}
          </span>
        ))}
      </div>
      {selected && (
        <div className={`mt-4 flex items-center gap-2 ${c.text}`}>
          <Check size={16} />
          <span className="text-sm font-semibold">Selected</span>
        </div>
      )}
    </button>
  );
};

export default PlatformCard;
